import { render, staticRenderFns } from "./NoCrmClientAlert.vue?vue&type=template&id=777c3237&lang=pug"
import script from "./NoCrmClientAlert.vue?vue&type=script&lang=js"
export * from "./NoCrmClientAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports